import { byRanking } from "./utils";

let macros = null;

function parseMacroGruppi(sports) {
    function parseMacroGruppo(mg) {
        return {
            aggregate: mg.ags,
            id: mg.id,
            descrizione: mg.d,
            isPrincipale: mg.pn,
            isLive: mg.lv,
            ranking: mg.rnk
        }
    }

    const result = {};
    for (let sportId in sports) {
        const sport = sports[sportId];

        const prematch = sport.pr?.map(mg => parseMacroGruppo(mg)).sort(byRanking) ?? [];
        const live = sport.lv?.map(mg => parseMacroGruppo(mg)).sort(byRanking) ?? [];
    
        result[sportId] = {
            prematch,
            live
        };
    }

    return result;
}

function deepCopyMacrogruppo(mg) {
    return {
        aggregate: [...mg.aggregate],
        id: mg.id,
        descrizione: mg.descrizione,
        isPrincipale: mg.isPrincipale,
        isLive: mg.isLive,
        ranking: mg.ranking
    }
}

function deepCopyMacrogruppi(macrogruppi) {
    const prematch = macrogruppi.prematch.map(mg => {
        return deepCopyMacrogruppo(mg);
    });
    const live = macrogruppi.live.map(mg => {
        return deepCopyMacrogruppo(mg);
    });
    return {
        prematch,
        live
    };
}

export let getMacrogruppi = function(sportId) {
    const mgData = JSON.parse(localStorage.getItem('xs_macrogruppi'));
    macros = parseMacroGruppi(mgData.mcs);
    getMacrogruppi = function(sportId) {
        if (macros[sportId] === undefined) {
            return undefined;
        } else {
            return deepCopyMacrogruppi(macros[sportId]);
        }
    }
	return getMacrogruppi(sportId);
}

export function getMacrogruppo(live, sportId, macroId) {
    const macros = live ? getMacrogruppi(sportId).live : getMacrogruppi(sportId).prematch;
    const index = macros.findIndex(macro => macro.id === macroId);
    if (index !== -1) {
        return macros[index];
    } else {
        return null;
    }
}
